export default {
  roleType(state) {
    if (!state.user) return ''
    switch (state.user.role_id) {
      case 10001:
        return 'master'
      case 10002:
        return 'teacher'
      case 20001:
        return 'student'
      case 40001:
        return 'region'
      default:
        return ''
    }
  },
  batchApplyShowGuideStatus(state) {
    const BATCH_APPLY_GUIDE_KEY = `isHasShowGuide-${state.user.id}`
    // console.log(BATCH_APPLY_GUIDE_KEY, localStorage.getItem(BATCH_APPLY_GUIDE_KEY))
    return localStorage.getItem(BATCH_APPLY_GUIDE_KEY)
  }
}
